import React, { Suspense, lazy } from 'react';
import {Button} from '@material-ui/core';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import ContactWidgetStyles from '../styles/contactWidgetStyles';
import { darken } from '@material-ui/core/styles';
import Views from '../lib/views';
import Icons from '../lib/icons';

const useStyles = makeStyles(ContactWidgetStyles);
const getColor = (props) => props.backgroundColor;
const getColorDark = (props) => darken(props.backgroundColor, .1);

const styles = {
    root: {
        width: '100%',
        marginBottom: '14px',
        background: getColor,
        height: '45px',
        justifyContent: 'space-between',
        boxShadow: '0px 4px 8px rgba(25, 38, 57, 0.2)',
        borderRadius: '21px',
        '&:last-child': {
            marginBottom: '0px',
            label: {
                color: 'orange'
            }
        },
        '&:hover': {
            background: getColorDark,
        }
    }
}

const ChannelButton = withStyles(styles)(({ backgroundColor, ...other }) => (
    <Button {...other} />
));

const Home = (props) => {
    React.useEffect(() => {
        // The phone channel can optionally provide a tracking script (in the case of callrail, this appears to primarily take a phone number and transform it based on some configured rules).
        const channelWithTrackingCode = props.channels?.length ? props.channels.find((item) => { return item.type === 'phone' && item.tracking_code; }) : null;
        if (channelWithTrackingCode) {
            // There may be a better way to inject a script from a provided string, but the following works:
            // 1. Parse the tracking code string (to a dom object) and grab the parsed script element. This provides some level of validation that there is a valid script tag present.
            // 2. Create a new script element and copy the parsed element's attributes to the new script tag.
            // 3. Add the new script to the body.
            const parsedTrackingScript = new DOMParser().parseFromString(channelWithTrackingCode.tracking_code, 'text/html');
            const trackingScript = parsedTrackingScript
                ? parsedTrackingScript.getElementsByTagName('script').item(0) // Adding this script tag to the page directly doesn't execute the script... we have to rebuild it.
                : null;
            if (trackingScript) {
                const newScript = document.createElement("script");
                // Copy over all the attributes from the parsed tracking script (potentially need more info than just src)
                [...trackingScript.attributes].forEach(i => {
                    newScript.setAttribute(i.name, i.value);
                });
                newScript.async = true;
                document.body.appendChild(newScript);

                // TODO -- not tested: if we have a multiprofile widget, we will need to add/remove the tracking script between profiles.
                return () => { document.body.removeChild(newScript); }
            }
        }
    }, []);

    const classes = useStyles({ isMobile: props.isMobile, isHideLogo: props.isHideLogo });

    const onChannelClick = (e, channel) => {
        e.preventDefault();
        switch (channel.type) {
            case 'text':
                props.setView(Views.contactForm);
                props.Analytics.trackEvent('channels', 'text');
                break;
            case 'call_request':
                props.setView(Views.callRequestForm);
                props.Analytics.trackEvent('channels', 'call_request');
                break;
            case 'custom':
                window.open(channel.url, channel?.is_open_in_new_tab ? '_blank' : '_parent');
                props.Analytics.trackEvent('channels', 'custom');
                break;
            case 'email':
                window.open('mailto:' + channel.email);
                props.Analytics.trackEvent('channels', 'email');
                break;
            case 'phone':
                let number = e.currentTarget.querySelector('#leadboxClickToCall').textContent;
                window.parent.postMessage({ key: 'clickToCall', data: number}, '*');
                props.Analytics.trackEvent('channels', 'call');
                break;
            default:
                console.error('Unknown channel type ' + channel.type);
                break;
        }
    };

    let channels = props.channels?.length ? props.channels.map((item, index) => {
        return <Suspense fallback={<div></div>}>
            <ChannelButton
                href={'javascript:void(0)'}
                backgroundColor={item.button_color}
                onClick={ e => onChannelClick(e, item) }
                startIcon={Icons[item?.icon] ? React.createElement(Icons[item.icon], {'aria-hidden': true, 'focusable': false}) : null}
                classes={
                    {
                        label: classes.channel_button,
                    }
                }
            >
                {item.text}
                {item.type === 'phone' &&
                    <span style={{ display: 'none' }} id="leadboxClickToCall" className="hidden">{item.phone}</span>
                }
            </ChannelButton>
        </Suspense>
    }) : null;

    return (
        <div>
            <div className={classes.home__body}>
                {channels}
            </div>
            <div className={classes.form__triangle}></div>
        </div>
    )
}

export default Home;
